// Hook odpowiedzialny za wysłanie zapytania o produkt

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

// parametry requestu do api
interface IRequest {
  message: string;
  email?: string;
  phone?: string;
}

// typ zwracanych danych
type IResponse = ICommandResponseSuccess;

const postProductAskQuestion = (productId: number, data: IRequest): Promise<IResponse> =>
  axios.post(`/products/${productId}/ask_question`, data);

export const usePostProductAskQuestion = (
  productId: number,
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => postProductAskQuestion(productId, data), options);

